import React from "react";
import { Container } from "./home.styles";
import { HeroSection } from "../../components/heroSection/heroSection.component";
import { HomeSecondSectionCard } from "../../components/homeSecondSectionCard/homeSecondSectionCard.section";
import { FormSection } from "../../components/formSection/formSection.component";
import {
  Prenews,
  SecondPrenews,
} from "../../components/verticalCard/verticalCard.component";
import { News } from "../../components/horizontalCard/horizontalCard.component";
import { BottomFormSection } from "../../components/bottomFormSection/bottomFormSection.component";
import { FeaturedPartners } from "../../components/featuredPartners/featuredPartners.component";
import Footer from "../../components/footer/footer.component";
import Header from "../../components/header/header.component";
import { ToastContainer } from "react-toastify";

const Home = () => {
  return (
    <Container>
      <Header />
      <HeroSection />
      <HomeSecondSectionCard />
      <FormSection />
      <Prenews />
      <News />
      <SecondPrenews />
      <FeaturedPartners />
      <BottomFormSection />
      <Footer />
 <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Container>
  );
};

export default Home;
